
export default {
    name: 'BonusCardLoading',
}
